module.exports = __webpack_public_path__ + "static/media/liftup-default-3.31bc78c5.jpg";